
import React from 'react';
import { Business } from '@/schemas/business'; // Changed to Zod-inferred type
import { BusinessLogo } from './BusinessLogo';

interface BusinessItemProps {
  business: Business; // Now Zod Business type
  onClick: (business: Business, event: React.MouseEvent) => void;
  isMenuItem?: boolean;
  showLogo?: boolean;
}

export const BusinessItem: React.FC<BusinessItemProps> = ({ 
  business, 
  onClick,
  isMenuItem = true,
  showLogo = true
}) => {
  const handleClick = (event: React.MouseEvent) => {
    // Prevent any default behavior and stop propagation
    event.preventDefault();
    event.stopPropagation();
    
    if (event.nativeEvent) {
      event.nativeEvent.stopImmediatePropagation();
    }
    
    onClick(business, event);
  };

  const displayName = business.displayName || business.name || 'Business'; // Use displayName or name
  const logoUrl = business.logoUrl as string | undefined; // logoUrl is not in Zod schema, cast if used
  
  const containerClasses = isMenuItem 
    ? "flex items-center gap-2 w-full py-2 px-3 cursor-pointer" 
    : "flex items-center gap-2";
  
  return (
    <div 
      className={containerClasses} 
      onClick={handleClick}
      role="button"
      tabIndex={0}
    >
      {!isMenuItem && showLogo && logoUrl && ( // Check if logoUrl exists
        <BusinessLogo 
          logoUrl={logoUrl} 
          businessName={displayName} 
          size="full" 
        />
      )}
      
      <div className="flex flex-col flex-1">
        <span className={`${isMenuItem ? "font-medium" : "text-gray-800 font-medium"}`}>
          {displayName}
        </span>
        {business.address && (
          <span className="text-xs text-gray-500">{business.address}</span>
        )}
      </div>
      
      {isMenuItem && showLogo && logoUrl && ( // Check if logoUrl exists
        <BusinessLogo 
          logoUrl={logoUrl} 
          businessName={displayName} 
          size="compact"
        />
      )}
    </div>
  );
};
